import styled from 'styled-components';
import { LAYOUT } from '@/constants/styles';

export const StyledUserInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledEmailVerification = styled.div`
  text-align: center;

  p {
    margin-bottom: ${LAYOUT.GUTTER * 1.5}px;
  }
`;

export const StyledPhoneDisclosure = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #595959;
  margin: 0px 16px 16px 16px;
`;
